export const customer_fields = [
    {
        key: 'id',
        label: '#',
        sortable: true
    },
    {
        key: 'first_name',
        sortable: true
    },
    {
        key: 'last_name',
        sortable: true
    },
    {
        key: 'phone_number',
        sortable: true
    },
    {
        key: 'national_id',
        sortable: true,
    },
    {
        key: 'date_created',
        label: 'Date',
        sortable: true,
    }
];
